module.exports = __webpack_public_path__ + "img/new-leaf-logo.5a7245a1.jpg";